var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-cards",
    {
      staticClass: "reco-mobile-card d-flex flex-column h-100",
      attrs: {
        "data-test-id": "reco-mobile-card",
        "additional-classes": "px-1 pt-2",
        "is-multiple": true,
        "with-composite-link": false,
      },
    },
    [
      _c(
        "a",
        {
          staticClass:
            "card-link-wrapper text-decoration-none text-dark d-block",
          attrs: {
            href: _vm.mobile.deviceSummary.detailsUrl,
            "data-pdb-zid": _vm.dataPdbZid + _vm.index,
            "data-pdb-sc": "adv",
            "data-pdb-idc": _vm.mobile.ean.value,
            "data-pdb-vi": _vm.dataPdbVi,
            "data-pdb-ta": _vm.mobile.advTracker,
            "data-oevent-category": "zone_recommandee_advise",
            "data-oevent-action": "bloc_" + _vm.index,
            "data-oevent-label": _vm.tagLabel(_vm.mobile.deviceSummary.name),
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column h-100 justify-content-between" },
            [
              _vm.mobile.deviceSummary.banner
                ? _c("ob1-tag", {
                    staticClass: "banner",
                    attrs: { label: _vm.mobile.deviceSummary.banner },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-row" }, [
                _vm.mobile.deviceSummary.image
                  ? _c("div", { staticClass: "img-device me-1 my-1" }, [
                      _c(
                        "div",
                        { staticClass: "image-container" },
                        [
                          _c("ob1-picture", {
                            staticClass: "device-picture",
                            attrs: { visual: _vm.mobile.deviceSummary.image },
                          }),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "infos pr-1" }, [
                  _c(
                    "div",
                    { staticClass: "mobile-infos" },
                    [
                      _c("div", [
                        _vm._v(_vm._s(_vm.mobile.deviceSummary.brand)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "h2",
                        {
                          staticClass:
                            "no-signature standard py-0 my-0 fw-normal",
                        },
                        [
                          _c(
                            "strong",
                            { staticClass: "standard device-name-wrapper" },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.mobile.deviceSummary.name) +
                                  "\n                            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.mobile.deviceSummary.reviewsStats
                        ? _c("Rating", {
                            attrs: {
                              average:
                                _vm.mobile.deviceSummary.reviewsStats.average,
                              "rating-results-height": 1.01,
                              "font-size": 0.875,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "infos-price" },
                    [
                      _c("device-price", {
                        attrs: {
                          "compact-price": true,
                          "is-cents-format": true,
                          "multiple-price":
                            _vm.mobile.deviceSummary.multiplePrices,
                          "total-price-with-promo":
                            _vm.mobile.deviceSummary.discountedPriceInCents,
                          "total-price-without-promo":
                            _vm.getPriceWithoutPromo(),
                          "monthly-amount-in-cents":
                            _vm.getMonthlyAmountInCents(),
                          "monthly-duration": _vm.getMonthlyDuration(),
                          "generic-label": _vm.getPaymentInfoLabel(),
                          "loan-rate-zero-label": _vm.getZeroRateLabel(),
                          "is-price-inversion-enabled":
                            _vm.isPriceInversionEnabled(),
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "infos-advantage py-1" },
                [
                  _vm.mobile.deviceSummary.advantageValues
                    ? [
                        _c("advantage-bloc", {
                          attrs: {
                            "advantage-messages": _vm.advantageMessages,
                            discount:
                              _vm.mobile.deviceSummary.advantageValues.discount,
                            odr: _vm.mobile.deviceSummary.advantageValues.odr,
                            "bonus-recovery":
                              _vm.mobile.deviceSummary.advantageValues
                                .bonusRecovery,
                          },
                        }),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _vm.showSoldByInfos
                ? _c(
                    "div",
                    { staticClass: "infos-seller" },
                    [
                      _c("sold-by-card", {
                        attrs: {
                          title: _vm.sellerLabel,
                          "sold-by-orange": _vm.mobile.deviceSummary.firstParty,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center payment-solutions-details pt-1",
        },
        [
          _vm.showDasTooltip(_vm.mobile)
            ? _c("das-tooltip", {
                staticClass: "me-auto",
                attrs: {
                  id: "tooltip-reco-" + _vm.index,
                  das: _vm.mobile.deviceSummary.dasAccessible,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mobile.deviceSummary.energyLabel
            ? _c("energy-label", {
                staticClass: "energy-label-padding ms-auto",
                attrs: {
                  id: _vm.mobile.deviceSummary.seoId,
                  "energy-label": _vm.mobile.deviceSummary.energyLabel,
                  "with-link": false,
                  "with-custom-image-class": true,
                  "with-popin": false,
                  "data-oevent-category": "selecteur_produit",
                },
                on: { energyLabelClick: _vm.handleEnergyLabelClick },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showFundingDetailsLink(_vm.mobile)
            ? _c("FundingDetailsLink", {
                staticClass: "ms-auto",
                attrs: {
                  "seo-id": _vm.mobile.deviceSummary.seoId,
                  text: _vm.fundingDetailsDto.linkText,
                },
                on: { fundingDetailsClick: _vm.handleFundingDetailsClick },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }